import { render, staticRenderFns } from "./Speech.vue?vue&type=template&id=29f89442&scoped=true&"
import script from "./Speech.vue?vue&type=script&lang=ts&"
export * from "./Speech.vue?vue&type=script&lang=ts&"
import style0 from "./Speech.vue?vue&type=style&index=0&id=29f89442&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f89442",
  null
  
)

export default component.exports